































import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Mixin from '../mixin';
import Auth from '@aws-amplify/auth';

@Component({})
export default class SubmitPassword extends Mixin {
  private user: string = '';
  private code: string = '';
  private pass: string = '';
  private repass: string = '';

  private mounted() {
    (this.$el.querySelector('#user') as HTMLInputElement).focus();
  }

  private async update(event: any) {
    if (event.target.disabled) {
      return;
    }
    event.target.disabled = true;
    try {
      if (this.user.length < 1) {
        this.msg('ユーザー名を入力してください');
        (this.$el.querySelector('#user') as HTMLInputElement).focus();
        return;
      }
      if (this.code.length < 1) {
        this.msg('リセットコードを入力してください');
        (this.$el.querySelector('#code') as HTMLInputElement).focus();
        return;
      }
      if (this.pass.length < 1) {
        this.msg('パスワードを入力してください');
        (this.$el.querySelector('#pass') as HTMLInputElement).focus();
        return;
      }
      if (this.pass !== this.repass) {
        this.msg('確認用のパスワードが異なります');
        return;
      }
      await Auth.forgotPasswordSubmit(this.user, this.code, this.pass);
      this.msg('パスワードを更新しました');
      this.$router.push('/');
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }
}
